<app-profile-confirm-modal [toDo]="'confirm'" *ngIf="confirmModal"></app-profile-confirm-modal>
<form 
  [formGroup]="phoneAccountForm" 
  name="phoneAccountForm"  
  (ngSubmit)="phoneAccountForm.valid && onSubmitPhoneDetails()">
  <mapfre-alert></mapfre-alert>
  <div class="row margin-top mt16">
      <div class="col">
        <div *ngFor="let input of inputs" class="inputs">
          <mapfre-validation 
          [input]="input" 
          [form]="phoneAccountForm"  
          [maximumLength]="'10'" 
          [phoneNumber]="phoneNumber"
          ></mapfre-validation>
        </div>
      </div>
    </div>
    <div class="row margin-top mt16">
        <div class="col">
      <ng-container *ngIf="route==='/profile/edit-phone'; else addPhone">
              <mapfre-button
                additionalClasses="basic primary large-btn no-margin w-100"
                [disabledValue]="phoneAccountForm.valid" 
                [inputType]="'submit'"
                [translateValue]="'UPDATE_PHONE_BUTTON' | translate"
              ></mapfre-button>
      </ng-container>
      <ng-template #addPhone>
          <mapfre-button
          additionalClasses="basic primary large-btn no-margin w-100"
          [disabledValue]="phoneAccountForm.valid" 
          [inputType]="'submit'"
          [translateValue]="'ADD_PHONE_BUTTON' | translate"
          ></mapfre-button>
      </ng-template>       
      </div>
    </div>
  </form>
  <div class="row margin-top mt24 text-center margin-bottom mb16">
    <div class="col">
      <mapfre-button
        (click)="onCheckDirty()"
        additionalClasses="link-button small-btn red-link no-margin button-border-red"
        [backIcon]="'assets/img/icons/back-arrow-red.png'"
        [iconClasses]="'align-middle'"
        [showIconsCustom]="true"
      >  {{ 'BACK' | translate }}
      </mapfre-button>
    </div>
  </div>